module.exports = __webpack_public_path__ + "img/login-background.f9f49138.jpg";